import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { RoomElementInteractors } from './interactors';
import { EditMeasures } from './../cmd/EditMeasure';
import { MeasureSnapping } from './MeasureSnapping';
export class MoveText extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mLengthFeedback = null;
    }
    initialize(pMode, pRoomElement) {
        this.mMode = pMode;
        this.mRoomElement = pRoomElement;
        this.mCommand = new EditMeasures(this.mRoomManager);
        this.mMeasureSnapping = new MeasureSnapping(this.mRoomManager);
        this.mInitialPos = new Vector3(0, 0, 0);
        this.mRE_WM = this.mRoomElement.node.getWorldMatrix();
        this.mREpos = this.mRoomElement.node.position.clone();
        this.prepareSnapping();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        this.mInitialPos = pPos;
        this.mInitialPos_transformed = Vector3.TransformCoordinates(this.mInitialPos, this.mRE_WM);
    }
    updatePointerPosition(pPos) {
        let tOffset = pPos.subtract(this.mRoomElement.node.position.clone());
        let tOffset_transformed = Vector3.TransformCoordinates(tOffset, this.mRE_WM.getRotationMatrix().invert());
        let tZ = tOffset_transformed.z * 2;
        this.mRoomElement.setTextHeight(tZ);
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        if (this.mCommand != null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
            });
        }
    }
    prepareSnapping() {
        super.prepareSnapping();
        /*
        if (this.mMode !== MoveText.Mode.MoveText) {
            this.mMeasureSnapping.prepareSnapping(this.mRoomElement, this.mMode === MoveText.Mode.MoveStart ?
                MeasureEnding.End : MeasureEnding.Start);
        }
        */
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        this.mLengthFeedback.showInteractors(false);
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mLengthFeedback != null)
            this.mLengthFeedback.showInteractors(false);
    }
    clearFeedback() {
        super.clearFeedback();
        this.mMeasureSnapping.clear();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
}
//add nested types
(function (MoveText) {
    let Mode;
    (function (Mode) {
        Mode[Mode["MoveStart"] = 0] = "MoveStart";
        Mode[Mode["MoveEnd"] = 1] = "MoveEnd";
        Mode[Mode["MoveText"] = 2] = "MoveText";
    })(Mode = MoveText.Mode || (MoveText.Mode = {}));
})(MoveText || (MoveText = {}));
